import { memo, useState } from "react";
import { CloseIcon } from "../assets/icons/ManageUsers";
import { useStateContext } from "../context/context";
import ModalCard from "../shared/Modal";
import { Customer } from "../typings";
import { postApi } from "../utils/services";
import { Toast } from "./Toast";

type Props = {
  data: Customer;
};

const ForceSignOut = (data: Props) => {
  const { handleClick } = useStateContext();
  const [loading, setLoading] = useState(false);

  const signOut = () => {
    setLoading(true);

    postApi(
      `${process.env.REACT_APP_BASE_URL_ARY}/Account/Logout-Phone?phone=${data?.data?.phoneNumber}`
    )
      .then((res) => {
        setLoading(false);
        Toast({ title: res?.responseMessage, error: false });
      })
      .catch((err: any) => {
        console.log("err", err);
        setLoading(false);
      });
  };
  return (
    <ModalCard>
      <div className="flex justify-center  flex-col space-y-7 w-[500px] p-16 bg-white rounded-xl ">
        <div className="flex items-center">
          <h4 className="ml-auto text-xl text-[#4C4D50] font-semibold">
            Force Sign-Out
          </h4>
          <p onClick={handleClick} className="cursor-pointer ml-auto">
            <CloseIcon />
          </p>
        </div>
        <p className="text-[#4C4D50] text-center ">
          Are you sure you want to force sign out this account ?
        </p>
        <div className="flex items-center justify-center space-x-6">
          <button
            onClick={handleClick}
            type="submit"
            className="btn text-[#1C1D21] bg-transparent border-[#1C1D21] border-2 font-semibold"
          >
            cancel
          </button>
          <button type="submit" onClick={signOut} className="btn">
            {loading ? "processing..." : " Sign Out"}
          </button>
        </div>
      </div>
    </ModalCard>
  );
};

export default memo(ForceSignOut);
